import { useState, useEffect } from "react";
import { LifeBuoy, Phone, X, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

const RESOURCES = [
  { name: "Samaritans", num: "116 123", desc: "Free, 24/7, confidential emotional support.", tel: "116123" },
  { name: "NHS 111", num: "111", desc: "Urgent medical help & advice (non-emergency).", tel: "111" },
  { name: "Emergency Services", num: "999", desc: "Life-threatening emergencies.", tel: "999" },
];

export const CrisisButton = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-crisis", handler);
    return () => window.removeEventListener("open-crisis", handler);
  }, []);
  return (
    <>
      <button
        data-testid="crisis-button"
        onClick={() => setOpen(true)}
        className="no-print fixed bottom-20 right-5 z-[60] flex items-center gap-2 rounded-full bg-[#D96C5B] px-5 py-3.5 text-white shadow-lg shadow-[#D96C5B]/30 transition-transform duration-300 hover:-translate-y-1 active:translate-y-0"
        style={{ minHeight: 52 }}
      >
        <LifeBuoy strokeWidth={1.8} className="h-5 w-5" />
        <span className="font-head font-semibold">Get Help Now</span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="crisis-modal" className="max-w-md rounded-2xl border-0 p-0 overflow-hidden">
          <DialogTitle className="sr-only">Get help now — crisis support</DialogTitle>
          <div className="bg-[#D96C5B] px-6 py-5 text-white">
            <div className="flex items-center justify-between">
              <h2 className="font-head text-2xl font-semibold">You're not alone</h2>
              <button onClick={() => setOpen(false)} data-testid="crisis-close"><X className="h-5 w-5" /></button>
            </div>
            <p className="mt-1 text-white/90 text-sm">Reach out — help is available right now.</p>
          </div>
          <div className="space-y-3 p-6">
            {RESOURCES.map((r) => (
              <a key={r.name} href={`tel:${r.tel}`} data-testid={`crisis-${r.tel}`}
                 className="flex items-center gap-4 rounded-2xl border border-border bg-white p-4 transition-transform duration-300 hover:-translate-y-0.5">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#4A7c59]/10 text-[#4A7c59]">
                  <Phone strokeWidth={1.8} className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-head font-semibold text-[#2C363F]">{r.name} · {r.num}</div>
                  <div className="text-sm text-muted-foreground">{r.desc}</div>
                </div>
              </a>
            ))}
            <div className="flex gap-3 rounded-2xl bg-[#E8907E]/15 p-4 text-sm text-[#8a4436]">
              <AlertTriangle strokeWidth={1.8} className="h-5 w-5 shrink-0" />
              <p>Stopping benzodiazepines abruptly can be dangerous. Seek urgent medical help for severe symptoms such as seizures, confusion or hallucinations.</p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
